import { render, staticRenderFns } from "./DataCheckbox.vue?vue&type=template&id=b31dbe4e&scoped=true&"
import script from "./DataCheckbox.vue?vue&type=script&lang=js&"
export * from "./DataCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./DataCheckbox.vue?vue&type=style&index=0&id=b31dbe4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b31dbe4e",
  null
  
)

export default component.exports